export default {"src":"/_next/static/media/enforce-guardrails.b1c48d62.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};